/**
 * Generic Events in the host-ux package
 */
export enum GenericEvent {
  /** Disconnected Banner was shown */
  DisconnectedBannerShown = 'DisconnectedBannerShown',
  /** PermissionsPanel: when there is more than one sharelink associated with a fluid file */
  MultipleShareLinks = 'MultipleShareLinks',
  /** PermissionsPanel: when there is one sharelink, type=specific */
  PeopleInChatAccess = 'PeopleInChatAccess',
  /** String table not being fetched */
  StringTableFetchError = 'StringTableFetchError'
}

/**
 * Subcategories of the Generic Event in the host-ux package
 */
export enum GenericEventSubcategories {
  MessageBanner = 'MessageBanner'
}
